import { number, shape } from 'prop-types'

const crossSellWidgetPropTypes = number

const crossSellStartPageAlternative = shape({ alternative: number })
const crosssSellExpaHidden = shape({
  startPage: crossSellStartPageAlternative,
})

export { crossSellWidgetPropTypes, crosssSellExpaHidden }
